import type { ResolvedRingStyle } from '../style';

interface RingProps {
  className: string;
  cx: number;
  cy: number;
  r: number;
  resolved: ResolvedRingStyle;
}

export default function Ring({ className, cx, cy, r, resolved }: RingProps) {
  const style = resolved.animated
    ? {
        stroke: resolved.color,
        strokeWidth: resolved.width,
        strokeDasharray: resolved.dash,
        animationDuration: `${Math.max(1, resolved.speed)}s`,
        animationDirection: resolved.spin,
      }
    : {
        stroke: resolved.color,
        strokeWidth: resolved.width,
        strokeDasharray: resolved.dash,
        animation: 'none' as const,
      };
  return (
    <circle className={className} cx={cx} cy={cy} r={r} style={style} />
  );
}
